import { FC, useContext } from 'react';
import { IPage } from '.';
import { UserContext } from '../../context';
import { INavLink } from '../../models';
import { Page } from './Page';

interface IOrderManagementPage extends IPage {
  sideBarLinks?: INavLink[];
}

export const OrderManagementPage: FC<IOrderManagementPage> = props => {
  const { user } = useContext(UserContext);
  return (
    <Page
      {...props}
      sideBarLinks={
        props.sideBarLinks &&
        props.sideBarLinks.filter(link => {
          // return all of the side bar links
          let hasNeededRoles = true;
          if (link.roles && link.roles.length > 0 && ((user.userRoles && user.userRoles.length > 0) || user?.placeOrder?.placeOrderRole)) {
            // return all of the side bar links if the user's userRoles includes BL_ADMIN or place order role of Billing Admin
            hasNeededRoles = (user?.userRoles?.some(r => link.roles.includes(r)) || !!user?.placeOrder?.placeOrderRole?.name) ?? false;
          }
          return hasNeededRoles;
        })
      }
    />
  );
};
